const escrowWalletPT = {
    "view": {
        "title": "Gerencie Sua Carteira de Escrow",
        "descriptionParagraph1": "Os fundos são retidos para garantir segurança e transparência durante o processo de verificação. Para faixas sinalizadas, uma taxa de <strong>15 €</strong> por faixa é retida em escrow para liberar a faixa para entrega no Spotify. Esses fundos serão reembolsados assim que os artistas da faixa forem verificados como legítimos.",
        "descriptionParagraph2": "Use a tabela abaixo para visualizar todas as transações de escrow. Para mais detalhes, <1><strong>Saiba Mais</strong></1>",
        "label": {
            "totalWithheld": "Total Retido",
            "totalRefunds": "Total de Reembolsos"
        },
        "escrowPayments": {
            "title": "Pagamentos de Escrow",
            "table": {
                "column": {
                    "paymentId": "ID do Pagamento",
                    "releaseName": "Lançamento",
                    "amount": "Quantia",
                    "paymentDate": "Data do Pagamento",
                    "paymentAgreement": "Acordo de Pagamento",
                    "refundProcessed": "Reembolso Processado",
                    "requestRefund": "Solicitar Reembolso",
                    "details": "Detalhes"
                },
                "placeholder": {
                    "search": "Pesquisar..."
                },
                "button": {
                    "download": "Baixar",
                    "exportCsv": "Exportar CSV",
                    "view": "Visualizar",
                    "requestRefund": "Solicitar Reembolso"
                },
                "label": {
                    "notAvailable": "Não Disponível"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Solicitar Reembolso",
                        "body": {
                            "description": "Tem certeza de que deseja solicitar um reembolso para este pagamento?",
                            "note": "Por favor, note que esta solicitação está sujeita a revisão pelo administrador e, se aprovada, será adicionada como uma declaração para a qual você pode emitir uma fatura."
                        },
                        "button": {
                            "confirm": "Confirmar",
                            "cancel": "Cancelar"
                        },
                        "message": {
                            "success": "Solicitação de Reembolso enviada com sucesso!",
                            "error": "Algo deu errado, por favor tente novamente mais tarde!"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Detalhamento do Pagamento de Escrow",
            "table": {
                "column": {
                    "paymentId": "ID do Pagamento",
                    "trackName": "Faixa",
                    "amount": "Quantia",
                    "paymentDate": "Data do Pagamento"
                }
            }
        },
        "escrowRefunds": {
            "title": "Reembolsos de Escrow",
            "table": {
                "column": {
                    "refundId": "ID do Reembolso",
                    "paymentId": "ID do Pagamento",
                    "release": "Lançamento",
                    "amount": "Quantia",
                    "requestDate": "Data da Solicitação",
                    "status": "Status"
                },
                "label": {
                    "pending": "Pendente",
                    "approved": "Aprovado",
                    "rejected": "Rejeitado"
                },
                "tooltip": {
                    "pending": "Sua solicitação de reembolso está atualmente pendente de revisão pelo administrador e será processada em breve.",
                    "approved": "Sua solicitação de reembolso foi aprovada e uma declaração foi adicionada para o valor do reembolso.",
                    "rejected": "Sua solicitação de reembolso foi rejeitada pelo administrador, você pode solicitar o reembolso novamente."
                },
                "placeholder": {
                    "search": "Pesquisar..."
                },
                "button": {
                    "exportCsv": "Exportar CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transação Bem-Sucedida :)",
            "description": "O pagamento de escrow foi concluído com sucesso, o lançamento relevante será liberado em breve!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transação Cancelada :(",
            "description": "A transação foi cancelada... Por favor, tente novamente mais tarde!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    }
};

export default escrowWalletPT;